import { styled } from 'next-yak';

export const CardBenefitsSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
